<template>
    <div v-if="isreadshow">
        <my-search @search="searchHandler" v-model="pgData" title-placeholder="公告名称/公告编码">
            <el-form-item slot="time"></el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" size="small" style="margin-bottom:10px;" @click="add()">添加</el-button>
            </template>
        </my-search>
        

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="公告名称" prop="ggname" min-width="220"></el-table-column>
            <el-table-column label="公告编码" prop="ggcode" min-width="220"></el-table-column>
            <el-table-column label="发布日期" prop="ggfbtime" min-width="220"></el-table-column>
            <el-table-column label="公告性质" prop="ggxzname" min-width="120"></el-table-column>
            <el-table-column label="公告类型" prop="gglxname" min-width="120"></el-table-column>
            <el-table-column label="交易中心"  min-width="160">
                <template slot-scope="scope">
                    <jyzx-state :data="scope.row"></jyzx-state>

                     <push-type 
                        :column="scope.row" 
                        :pushPage="'zbgg'" 
                        :primaryKey="scope.row.ggcode"
                        :procode="getQuery('procode')">
                    </push-type>

                </template>
            </el-table-column>
            <el-table-column label="发布状态">
                <template slot-scope="scope">
                    <my-tag type="warning" v-if="scope.row.shbj==='0'" @click="showTips()">未提交</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='1'" @click="showTips()">已提交待内部审核</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='7'&&scope.row.tbzt==='1'&&listData.ishbpsp!=='1'" @click="showTips()">待平台审核</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='9'&&scope.row.tbzt==='1'" @click="showTips()">同步中</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='9'&&scope.row.tbzt==='2'" @click="showTips()">备案部门待审核</my-tag>
                    <my-tag type="success" v-if="scope.row.shbj==='9'&&scope.row.tbzt==='9'" @click="showTips()">已发布</my-tag>
                    <div v-if="scope.row.shbj==='3'">
                        <my-tag  type="danger">已退回</my-tag>
                        原因：{{scope.row.by2}}
                    </div>
                    <my-tag type="primary" v-if="scope.row.shbj==='6'&&scope.row.xtts==='1'" @click="showTips()">待交易中心审核</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='6'&&scope.row.xtts!=='1'" @click="showTips()">未推送交易中心</my-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="160">
                <template slot-scope="scope">
                    <my-btn 
                        v-if="scope.row.shbj==='1'||scope.row.shbj==='9'||scope.row.shbj==='6'||scope.row.shbj==='8'" type="detail" 
                        @click="show(scope.row.ggcode,pgData.procode)">
                            详情
                    </my-btn>
                    <div v-if="scope.row.shbj==='1'||scope.row.shbj==='9'||scope.row.shbj==='6'">
                        
                        <my-btn type="edit" @click="edit(scope.row.ggcode,'1')" v-if="scope.row.ggxzcode==='1'">发布变更公告</my-btn>
                    </div>
                    <div v-if="scope.row.shbj!=='1'&&scope.row.shbj!=='9'&&scope.row.shbj!=='6'&&scope.row.shbj!=='8'">
                        <my-btn type="del" @click="del(scope.row.ggcode)">删除</my-btn>
                        <my-btn type="edit" @click="edit(scope.row.ggcode,'0')">修改</my-btn>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/FangAn/Zbgg/xingtai/get_list.json`"></my-pagination>
       
        <el-dialog  :visible.sync="shztdialogVisible" title="发布状态提示" width="30%">
            <div class="shzt">
                <el-timeline>
                    <el-timeline-item color="#409EFF">
                        已提交待内部审核——请在综合管理-招标公告审核处进行审核！
                    </el-timeline-item>
                    <el-timeline-item color="#409EFF">
                        同步中——已提交审核部门！
                    </el-timeline-item>
                    <el-timeline-item color="#409EFF">
                        备案部门待审核——已提交至备案部门，等待备案部门审核！
                    </el-timeline-item>
                    <el-timeline-item color="#409EFF">
                        已发布——审核已通过，公告已发布！
                    </el-timeline-item>
                    <el-timeline-item color="#409EFF">
                        已退回——审核未通过，公告被退回！
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page';
import JyzxState from '@views/bidding/components/jyzx-state'
import PushType from '@/components-sys/push-type'
export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {
        PushType,JyzxState
    },
    data() {
        return{
            shztdialogVisible:false,
            listData:{
                ishbpsp:'',
            },
            pgData:{
                procode:'',
                sortname : 'addtime',              
            },
            isreadshow:true,
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //查看所有发布状态
        showTips:function(){
            this.shztdialogVisible=true;
        },
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //删除
        del:function(ggcode){
            var that=this;         
            that.$post(`${this.getGetters('bidUrl')}/FangAn/Zbgg/xingtai/del`,{id:ggcode}, (data, res) => {
                ShowMsg('删除成功', 'success');
                that.reload();
            }); 
        },
        //详情
        show:function(ggcode){
            this.goto({
                path:'./detail',
                query:{
                    ggcode:ggcode,
                    procode:this.pgData.procode
                }
            });
        },
    
        //添加
        add:function(){
            this.goto({
                path:'./form',
                query:{
                    procode:this.pgData.procode
                }
            });
        },
        //修改
        edit:function(ggcode,code,ggxzcode){
            var that = this;
            if(code==='0'){
                this.goto({
                    path:'./form',
                    query:{
                        ggcode:ggcode,
                        procode:that.pgData.procode,
                    }
                });
            }else{
                this.goto({
                    path:'./form',
                    query:{
                        yggcode:ggcode,
                        procode:that.pgData.procode,
                    }
                });
            }

        }
    },
    created() {
        var that = this;
        if(this.$route.query.procode!=undefined){
            this.pgData.procode=this.$route.query.procode
        }

    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
.gglrfs{width:100%;display: flex;justify-content: space-between;margin-bottom:20px;}
.gglrfs .ggtj{width: 40%;height:40px;line-height:40px;padding-left:10px;border:1px solid #157FCC;border-radius:4px;cursor:pointer;color:#157FCC;}
.gglrfs .ggtj:hover{background: #157FCC;border:1px solid #157FCC;color:#fff;}
// .shzt{width: 100%;height:400px;line-height: 50px;}
</style>
